export const GET_CSRF_SUCCESS = 'GET_CSRF_SUCCESS'
export const GET_MODULES = 'GET_MODULES'
export const GET_MODULES_SUCCESS = 'GET_MODULES'
export const GET_MODULES_ERROR = 'GET_MODULES_ERROR'
export const SUBMIT_FEEDBACK_SUCCESS = 'SUBMIT_FEEDBACK_SUCCESS'
export const SUBMIT_FEEDBACK_ERROR = 'SUBMIT_FEEDBACK_ERROR'
export const SET_VIDSIZE_SUCCESS = 'SET_VIDSIZE_SUCCESS'
export const SET_VIDSIZE_ERROR = 'SET_VIDSIZE_ERROR'
export const SET_VOLUNTARY_SUCCESS = 'SET_VOLUNTARY_SUCCESS'
export const SET_VOLUNTARY_ERROR = 'SET_VOLUNTARY_ERROR'
export const GET_FEEDBACK_GROUP_SUCCESS = 'GET_FEEDBACK_GROUP_SUCCESS'
export const GET_FEEDBACK_GROUP_ERROR = 'GET_FEEDBACK_GROUP_ERROR'
export const SET_FEEDBACK = 'SET_FEEDBACK'
export const GET_VIDEOS_SUCCESS = 'GET_VIDEOS_SUCCESS'
export const GET_VIDEOS_ERROR = 'GET_VIDEOS_ERROR'
export const FEEDBACK_COMPLETE = 'FEEDBACK_COMPLETE'